import { createStyles } from '@mantine/core'

type StylesParams = {
  touchSize: number
  iconSize: number
  isZalo: boolean
  bgZaloColor: string
}

export default createStyles(
  (theme, { touchSize, iconSize, isZalo, bgZaloColor }: StylesParams) => {
    return {
      item: {
        transition: 'width 0.3s ease',
        opacity: 1,
        width: touchSize,
        height: touchSize,
        'svg, img': {
          borderRadius: 4,
        },
        img: {
          flex: 0,
          width: 'auto !important',
          height: 'auto !important',
          maxWidth: iconSize,
          maxHeight: iconSize,
        },
        '.zalo-share-button': {
          position: 'absolute !important' as any,
          top: '50%!important' as any,
          left: '50%!important' as any,
          transform: 'translate(-50%,-50%)',
          zIndex: 1,
          iframe: {
            top: '1px !important' as any,
          },
        },
        '& >*:not(style)': {
          overflow: 'visible',
        },
      },
      itemInner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(isZalo && {
          position: 'absolute',
          pointerEvents: 'none',
          cursor: 'pointer',
          zIndex: 3,
        }),
      },
      zaloOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: bgZaloColor || theme.colors.gray[1],
        zIndex: 2,
        pointerEvents: 'none',
      },
    }
  },
)
